const { METHOD_SNOWBALL, METHOD_SNOWBALLTWO, METHOD_AVALANCHE, METHOD_FREELANCE, OVERLAY_RECURRINGSAVING } = require("./LoanConstants");
const moment = require("moment");
const _ = require("lodash");
const Overlay = require("./Overlay");

const monthFormat = "MM/YYYY";
const dayFormat = "D-MMM-YYYY";

class LoanPortfolio {
  constructor(method) {
    this.loans = [];
    this.processedLoans = [];
    this.overlays = [];
    /**
      Debt Snowball — Lowest to highest balance
      Debt Snowball II — Shortest to longest term
      Debt Avalanche — Highest to lowest interest rate
      Freelance — Priority order
     */
    this.method = method;
    // By default pay highest interest rate loans first
    // this.type = "onetimesaving"; // 'onetimesaving', 'recurringsaving', 'onetimeincome', 'recurringincome'
    // this.amount = 0; // Extra payment amount
    // this.startDate = new Date(); //  Extra payment start date
  }

  // Comparator functions
  compareLoansByDate(a, b) {
    const instA = a.startDate;
    const instB = b.startDate;
    let comparison = 0;
    if (instA > instB) {
      comparison = 1;
    } else if (instA < instB) {
      comparison = -1;
    }
    return comparison;
  }

  compareDates(a, b) {
    const instA = new Date(a).getTime();
    const instB = new Date(b).getTime();
    let comparison = 0;
    if (instA > instB) {
      comparison = 1;
    } else if (instA < instB) {
      comparison = -1;
    }
    return comparison;
  }

  compareInterestRates(a, b) {
    const instA = a.rate;
    const instB = b.rate;
    let comparison = 0;
    if (instA > instB) {
      comparison = 1;
    } else if (instA < instB) {
      comparison = -1;
    }
    return comparison;
  }

  compareReverseInterestRates(a, b) {
    const instA = a.rate;
    const instB = b.rate;
    let comparison = 0;
    if (instA > instB) {
      comparison = -1;
    } else if (instA < instB) {
      comparison = 1;
    }
    return comparison;
  }

  compareDatesWithName(a, b) {
    if (moment(a.name, dayFormat) < moment(b.name, dayFormat)) {
      return -1;
    }
    if (moment(a.name, dayFormat) > moment(b.name, dayFormat)) {
      return 1;
    }
    // a must be equal to b
    return 0;
  };

  compareReversePrincipalAmount(a, b) {
    const instA = a.originalLoanAmount;
    const instB = b.originalLoanAmount;
    let comparison = 0;
    if (instA > instB) {
      comparison = 1;
    } else if (instA < instB) {
      comparison = -1;
    }
    return comparison;
  }

  getEarliestMonthlyPaymentDate() {
    // console.log("Loans: ", this.loans);
    this.loans.sort(this.compareLoansByDate);
    // console.log("Sorted loans: ", this.loans);
  }

  addLoanToPortfolio(loan) {
    this.loans.push(loan);
  }

  setLoans(loans) {
    this.loans = [];
    loans.forEach(loan => this.loans.push(loan));
  }

  addOverlayToPortfolio(overlay) {
    this.overlays.push(overlay);
  }

  setOverlays(overlays) {
    this.overlays = [];
    overlays.forEach(overlay => this.overlays.push(overlay));
  }

  getSortedMaturityDates() {
    let maturityDates = [];
    this.loans.forEach(loan => {
      maturityDates.push(new Date(loan.calculateMaturityDate()));
    });
    return maturityDates.sort(this.compareDates);
  }


  // Calculations
  calculatePortfolioBalance() {
    let total = 0;
    this.loans.forEach(loan => {
      total += loan.principal;
    });

    return total;
  }

  calculatePortfolioCurrentBalance() {
    let total = 0;
    this.loans.forEach(loan => {
      total += loan.currentBalance;
    });

    return total;
  }

  calculateWeightedAverageInterest() {
    let total = 0;
    let perLoanWeightFactor = 0;
    this.loans.forEach(loan => {
      perLoanWeightFactor += (loan.principal * loan.rate) / 100;
      total += loan.principal;
    });

    return parseFloat(((perLoanWeightFactor / total) * 100).toFixed(2));
  }

  calculateTotalInterest() {
    let result = 0;
    this.processedLoans.map(loan => {
      result += loan.getTotalInterest()
    })
    return result
  }

  calculatePayoffDate() {
    return moment(this.getSortedMaturityDates()[this.getSortedMaturityDates().length - 1]).format(dayFormat);
  }

  calculatePayoffTime(retunType = 'string') {
    let now = moment(new Date());
    let lastPaymentDate = moment(this.getSortedMaturityDates()[this.getSortedMaturityDates().length - 1]);
    let years = lastPaymentDate.diff(now, "year");
    now.add(years, "years");
    let mos = lastPaymentDate.diff(now, "months");
    if (retunType == 'string') {
      if (years === 0) {
        return `${Math.abs(mos)} months`;
      }
      return `${Math.abs(years)} years and ${Math.abs(mos)} months`;
    } else {
      if (years === 0) {
        return mos;
      }
      return years * 12 + mos;
    }
  }

  printAmortization(loan) {
    let ams = loan.getAmortization();
    ams.forEach(payment => {
      console.log(
        `Month: ${payment.month} Date: ${payment.date} Payment: ${payment.monthlyPayment} Balance: ${payment.outstandingBalance}`
      );
    });
  }

  calculateMonthlyPaymentWithOverlays() {
    // 1 loan, apply all overlays
    if (this.loans.length === 1 && 0) { // Skip this 
      let singleLoan = this.loans[0];
      this.overlays.forEach(overlay => singleLoan.addOverlay(overlay));
      return singleLoan.calculateMonthlyPaymentWithOverlays();
    } else {
      // Multiple loans
      // Determine the method
      // If the method === METHOD_AVALANCHE,
      // console.log("Original overlays: ", this.overlays);
      let sortedLoans = [];
      let overlays = [];
      let startDate = '';
      switch (this.method) {
        case METHOD_AVALANCHE:
          // console.log("AVALANCCCC!!!!!");
          // console.log("Ordering loans for METHOD_AVALANCHE: ");
          sortedLoans = this.loans.sort(this.compareReverseInterestRates);
          // console.log("Sorted loans: ", sortedLoans);

          // console.log("Overlays: ", this.overlays);

          // Copy of the overlays
          overlays = _.cloneDeep(this.overlays);
          // console.log("Sorted loans: ", sortedLoans);

          sortedLoans.map((loan, index) => {
            // Apply overlays to highest-interest loan
            // console.log(`---------------------- LOAN ${loan.name} START -----------------------------`);

            // console.log("Months before overlays: ", loan.getTotalMonths());

            // Add overlays to the first loan
            // console.log("begin map");
            // console.log("New overlays: ", overlays);
            // overlays.map(overlay => {
            //   loan.addOverlay(overlay);
            // });
            loan.setOverlays(_.cloneDeep(overlays));

            // Print amortizations
            // this.printAmortization(loan);

            // console.log("end map");

            // console.log("Months after overlays: ", loan.getTotalMonths());
            loan.getAmortization(true);

            // console.log(`---------------------- LOAN ${loan.name} DONE -----------------------------`);

            // Reset overlay dates to last loan's maturity date
            // console.log("begin add overlay");

            // overlays = _.cloneDeep(overlays);

            // Only for the second loan and higher
            // if (index > 0) {
            startDate = loan.calculateMaturityDate();
            overlays.map(overlay => {
              // console.log(
              //   `Setting up overlay ${overlay.amount} with date of ${overlay.startDate} for loan principal $${
              //     loan.principal
              //   }: ${loan.calculateMaturityDate()}`
              // );

              // console.log(`Overlay start date: ${overlay.startDate}  Loan maturity date: ${startDate}`);

              if (moment(overlay.startDate, dayFormat) < moment(startDate, dayFormat)) {
                // console.log(`Setting overlay ${overlay.amount} start date: ${startDate}`);
                overlay.startDate = startDate;
              } else {
                // console.log(`Keeping overlay ${overlay.amount} start date: ${overlay.startDate}`);
              }
            });

            // Add the previous loan's monthly payment as a new overlay for the remainer of the loans
            overlays.push(new Overlay(loan.calculateMonthlyPayment(), OVERLAY_RECURRINGSAVING, startDate));
            // }
            // console.log(`OVERLAYS: ${JSON.stringify(overlays)}`);

            // console.log("end add overlay");

            // console.log("Loan overlays: ", loan.overlays);
          });

          sortedLoans.forEach(loan => this.processedLoans.push(loan));
          // console.log("Loans: ", this.loans);

          // console.log("Modified overlays: ", overlays);

          let pmt = 0;
          sortedLoans.forEach(loan => (pmt += loan.calculateMonthlyPaymentWithOverlays()));
          return pmt;
          break;

        case METHOD_SNOWBALL:
          sortedLoans = this.loans.sort(this.compareReversePrincipalAmount);
          // Copy of the overlays
          overlays = _.cloneDeep(this.overlays);
          // console.log("Sorted loans: ", sortedLoans);

          sortedLoans.map((loan, index) => {

            loan.setOverlays(_.cloneDeep(overlays));

            loan.getAmortization(true);

            startDate = loan.calculateMaturityDate();
            overlays.map(overlay => {
              if (moment(overlay.startDate, dayFormat) < moment(startDate, dayFormat)) {
                overlay.startDate = startDate;
              } else {
                // console.log(`Keeping overlay ${overlay.amount} start date: ${overlay.startDate}`);
              }
            });

            // Add the previous loan's monthly payment as a new overlay for the remainer of the loans
            overlays.push(new Overlay(loan.calculateMonthlyPayment(), OVERLAY_RECURRINGSAVING, startDate));
          });
          sortedLoans.forEach(loan => this.processedLoans.push(loan));

          let payment = 0;
          sortedLoans.forEach(loan => (payment += loan.calculateMonthlyPaymentWithOverlays()));
          return payment;
          break;

        default:
          break;
      }
    }
    return null;
  }

  // Chart data by principal
  getBalanceRemainingTimeSeriesData(graphBy) {
    // Prepare chart data
    let chartData = [];
    this.processedLoans.map(loan => {
      // console.log('amort => ', loan.getAmortization());
      let amort = loan.getAmortization();
      let principalPaid = 0;
      let interestPaid = 0;
      amort.map(entry => {
        // If its not in the array, push
        // let found = chartData.filter(item => item.name === entry.date);
        // console.log(`Found value: ${found}`);

        let _outstanding = entry.outstandingBalance;
        if (graphBy === 'interest') {
          interestPaid += entry.interestAmount;
          _outstanding = interestPaid;
        } else if (graphBy === 'monthlypayment') {
          _outstanding = entry.monthlyPayment + entry.extraPrincipal;
        } else if (graphBy === 'percenttowordprincipal') {
          //principalPaid += entry.principalAmount + entry.extraPrincipal;
          principalPaid += entry.principalAmount;
          _outstanding = entry.percentTowardsPrincipal;
        }
        chartData.push({
          date: entry.date,
          name: loan.name,
          outstandingBalance: _outstanding,
        });
      });
    });

    // Group by date
    let grouped = _.groupBy(chartData, 'date');
    // console.log('grouped: ', grouped)

    // Clean the data further
    let cleanData = [];
    Object.keys(grouped).forEach(item => {
      let gg = grouped[item];
      // console.log('Item: ', gg);
      let ggData = {};
      ggData.name = moment(item, dayFormat).format(dayFormat);
      gg.forEach(loanEntry => {
        ggData[loanEntry.name] = loanEntry.outstandingBalance;
      });
      cleanData.push(ggData);
      // cleanData.push
      // {name: 'Page A', uv: 4000, price: 2400, amt: 2400},
    });

    // console.log('clean data: ', cleanData)

    let result = cleanData.sort(this.compareDatesWithName)
    // console.log('result: ', result)

    return result;
  }

  // Calculate total loans and loan balance by 1st of month 
  getLonsStatasticsByCurrentMonth(loans, type) {
    let totalOriginal = 0
    let totalCurrent = 0
    loans.forEach(loan => {
      totalCurrent += loan.currentBalance
      totalOriginal += loan.originalLoanAmount
    })
    return Math.floor(((totalOriginal - totalCurrent) / totalOriginal) * 100)
  }
}

module.exports = LoanPortfolio;
